import { useState } from "react";

import { aiApiClient } from "@src/api/ai-api";

export const useCancelWorkflow = () => {
  const [isPending, setIsPending] = useState(false);

  const mutate = async (sessionId: string, source?: string) => {
    setIsPending(true);
    try {
      await aiApiClient.post(`/workflows/execution/${sessionId}/cancel`, {
        source,
      });
    } finally {
      setIsPending(false);
    }
  };

  return { mutate, isPending };
};
